module.exports = __webpack_public_path__ + "static/img/bg-overview@m.af479dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/bg-overview@m.jpg
// module id = P/el
// module chunks = 0